export default __webpack_public_path__ + "static/media/backer-atom-heart.83dadfba.svg";